import { useNavigate } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'small';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/article/${comic.id}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (size === 'small') {
    return (
      <button
        onClick={handleClick}
        className="flex gap-3 p-3 rounded-lg bg-background-50 hover:bg-background-100 transition-colors cursor-pointer text-left w-full group"
      >
        <div className="w-16 h-[88px] flex-shrink-0 rounded-md overflow-hidden">
          <img
            src={comic.coverImage}
            alt={`${comic.title} - 布丁漫画韩漫推荐`}
            title={`${comic.title} - 布丁漫画韩漫推荐`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-foreground-900 truncate">{comic.title}</h4>
          <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
          <div className="flex items-center gap-1 mt-2">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
            </div>
            <span className="text-xs font-medium text-accent-600">{comic.rating}</span>
          </div>
        </div>
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      className="group cursor-pointer text-left w-full"
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-100">
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 布丁漫画韩漫推荐`}
          title={`${comic.title} - 布丁漫画韩漫推荐`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex gap-1.5">
          {comic.isHot && (
            <span className="px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-[10px] font-medium whitespace-nowrap">
              热门
            </span>
          )}
          {comic.isNew && (
            <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-[10px] font-medium whitespace-nowrap">
              新番
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-white text-xs line-clamp-2">{comic.description}</p>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 truncate">{comic.title}</h3>
      <div className="flex items-center justify-between mt-1.5">
        <div className="flex items-center gap-1">
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
          </div>
          <span className="text-xs font-medium text-accent-600">{comic.rating}</span>
        </div>
        <span className="text-[11px] text-foreground-400">{comic.chapters}话</span>
      </div>
    </button>
  );
}